<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLElement>> = $props()
</script>

<kbd
	bind:this={ref}
	class={cn(
		"bg-muted text-muted-foreground in-data-[slot=tooltip-content]:text-background in-data-[slot=tooltip-content]:bg-background/10 pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-sm px-1 font-sans text-xs font-medium select-none [&_svg:not([class*='size-'])]:size-3",
		className
	)}
	data-slot="kbd"
	{...restProps}
>
	{@render children?.()}
</kbd>
